"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyKioskConfigSchema = exports.OilBlendingKioskConfigSchema = void 0;
const zod_1 = require("zod");
/**
 * Per-kiosk-type configuration schemas.
 *
 * Each kiosk type stores its own shape under `config` on the Kiosk entity.
 * The KIOSK_TYPES registry (registry.ts) maps a kioskType string to its
 * Zod validator so the API can validate config on provision/patch without
 * the lifecycle handlers needing to know each type.
 *
 * Adding a new kiosk type later = add a new schema here + a new registry entry.
 * No changes to kiosks-service handlers required.
 */
/**
 * Oil Blending kiosk — the first concrete type.
 *
 * Submissions broadcast over the existing location-scoped WebSocket channel
 *   `tenant:{tenantId}:location:{locationId}:blend-selections`
 * so EVERY register at the location sees the row in its Pending Blends
 * drawer; the first to Claim wins, others auto-remove on the
 * `blend-selection-claimed` event. No per-kiosk register link required.
 */
exports.OilBlendingKioskConfigSchema = zod_1.z.object({
    /** Master switch — allow customers to build their own blend (vs picking from signatures only). */
    allowBuildYourOwn: zod_1.z.boolean().default(true),
    /**
     * Optional whitelist — restrict the moods shown on this kiosk.
     * Empty / undefined = show all moods the tenant has enabled.
     */
    pinnedMoods: zod_1.z.array(zod_1.z.string()).optional(),
});
/**
 * Generic placeholder schema for kiosk types that don't define their own.
 * Useful for future types whose config is just `{}` initially.
 */
exports.EmptyKioskConfigSchema = zod_1.z.object({}).strict();
//# sourceMappingURL=kiosk-config.schemas.js.map